import React, { memo } from "react";
import styled from "styled-components";
import { RoundedIcon } from "../../rounded-icon/rounded-icon";

export enum borderStyles {
  dashed = "dashed",
  solid = "solid",
}

export enum status {
  disabled = "disabled",
  unavalable = "unavalable",
}

interface IProps {
  explanation: string;
  borderStyle?: borderStyles;
  status?: string;
  icon?: string;
  position?: string;
}

const LegendWrapper = styled.div`
  display: flex;
  margin: 5px;
`;

const LegendItem = styled.div`
  padding: 0 10px;
  display: flex;
  align-items: center;
`;

const LegendTitle = styled.div`
  text-align: center;
  font-size: 10px;
  color: ${(props) => props.theme.textColorGray};
  padding-left: 8px;
`;

const LegendCircle = styled.div`
  position: relative;
  display: flex;
  min-width: 30px;
  height: 30px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: ${(props) => props.theme.legendBorderGray};
  background-color: ${(props) => props.theme.primaryColor}40;

  &.dashed {
    border: 1px dashed ${(props) => props.theme.legendBorderGray};
  }

  &.solid {
    border: 1px solid ${(props) => props.theme.legendBorderGray};
  }

  &.disabled {
    opacity: 0.4;
    background-color: transparent;
  }

  &.unaivalable {
    background-color: ${(props) => props.theme.primaryColor}10;
  }
`;

const Item = (props: IProps) => {
  return (
    <LegendWrapper>
      <LegendItem>
        <LegendCircle
          className={`${props.borderStyle} ${props.status}
            }`}
        >
          {props.icon && (
            <RoundedIcon icon={props.icon} position={props.position} />
          )}
        </LegendCircle>
        <LegendTitle>{props.explanation}</LegendTitle>
      </LegendItem>
    </LegendWrapper>
  );
};
export const CalendarLegendItem = memo(Item);
